<ng-container *ngIf="{
                    blockInteraction: blockInteraction$ | async,
                    showSpinner: showSpinner$ | async
                  } as observables">
  <div class="spinner-container moo-spinner-container" *ngIf="observables.blockInteraction || observables.showSpinner">
    <div class="moo-show-spinner" *ngIf="observables.showSpinner">
      <div class="spinner-border moo-spinner-border text-primary"></div>
    </div>
  </div>
</ng-container>
